<div class="account-member-hero-header">
    <shared-hero-header [center]="isCenter" [preHeaderCenter]="isCenter" preTitle="MEMBER DETAILS" marginBottom="none"
        class="account-member-hero-header__hd">
        {{memberFullName$ | async}}
    </shared-hero-header>

    <shared-emphasis-text [underline]="false" class="account-member-hero-header__card-number"
        *ngIf="showMemberCardNumber$ | async">
        Your card number is: #{{memberCardNumber$ | async}}
    </shared-emphasis-text>

    <div class="account-member-hero-header__actions">
        <ng-container *ngIf="hasLoyaltyCard$ | async">
            <ng-template #mobile>
                <shared-btn class="account-member-hero-header__btn -for-loyalty-card"
                    (onClick)="handleOpenCardClick($event)" [size]="btnSize" [inverted]="true" feel="primary">Open card
                </shared-btn>
            </ng-template>
            <projection-for-device [mobile]="mobile"></projection-for-device>
        </ng-container>

        <shared-link class="account-member-hero-header__link" (onClick)="handleSignOut($event)" [inverted]="true"
            [emphasis]="false">
            Sign out
        </shared-link>

    </div>
</div>